module.exports = __webpack_public_path__ + "static/img/presysBriefIntroductionBg.f0f234b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysBriefIntroductionBg.jpg
// module id = 8p5M
// module chunks = 1